import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'
import moment from 'moment'

Vue.prototype.$moment = moment

Vue.config.productionTip = false

/* var express = require('express');
var cors = require('cors');
var app = express();
app.use(cors()); */

const vm = new Vue({
  router,
  store,
  data: {
    pooling: '',
    authRefresh: ''
  },
  render: function (h) { return h(App) },
  methods: {

    fetchConfigs: function( fetch = false ) {

      if(!store.state.authToken.length) {
        this.requestAuth(true)
      } else {
        axios
        .get(process.env.VUE_APP_API_URL+'/configs', {
          headers: {
            'Authorization': 'Bearer '+store.state.authToken
          }
        })
        .then( function(response){
  
          store.commit('setConfigs', response.data.configs);
          
          if(fetch) {
            vm.fetchConfigs()

            vm.pooling = setInterval( function(){
              vm.fetchConfigs();
              vm.refreshAuth();
            }.bind(vm), 60000);
          }
  
        }).catch(function(err) {
          //vm.requestAuth();
          console.log(err);
        }); 
      }

    },

    requestAuth: function( fetch = false) {

      const authToken = getCookie('authToken');
      const vc = this;
      
      if(authToken.length) {

        const refreshToken = getCookie('refreshToken');

        axios.get(process.env.VUE_APP_API_URL+'/configs', {
          headers: {
            'Authorization': 'Bearer '+authToken
          }
        })
        .then( function(response){

          store.commit('setAuthToken', authToken)
          store.commit('setRefreshToken', refreshToken)
          store.commit('setConfigs', response.data.configs);

          if(fetch) {
            vm.pooling = setInterval( function(){
              vm.fetchConfigs();
              vm.refreshAuth();
            }.bind(vm), 60000);
          }
        
        }).catch(function(err) {

          console.log(err);
          clearInterval(vm.pooling);
          document.cookie = "authToken=; Path=/; SameSite=Lax;  Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
          document.cookie = "refreshToken=; Path=/; SameSite=Lax;  Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
          store.commit('setAuthToken', '')
          store.commit('setRefreshToken', '')

          if(vc.$route.name !== 'LogIn')
            router.push('/')
        }); 
      } else if( !['LogIn', 'HomePage', 'ConfManage', 'PublicConfigParams', 'DownloadPublicConfig', 'ApiDocs', 'ConfigurationSnippet', 'PublicTuningGuide'].includes(this.$route.name) ) { 
        document.cookie = "authToken=; Path=/; SameSite=Lax;  Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        document.cookie = "refreshToken=; Path=/; SameSite=Lax;  Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        store.commit('setAuthToken', '')
        store.commit('setRefreshToken', '')
        router.push('/')
      } else if ( (this.$route.name == 'LogIn') && !window.location.search.length)
        window.location.href = process.env.VUE_APP_LOGIN_URL;
    },

    refreshAuth: function() {

      // Check if session is about to expire
      var a = this.$moment()
      var b = this.$moment(getCookie('refreshTokenExpire'))
      
      //console.log(b.diff(a, 'minutes'))
 
      if(b.diff(a, 'minutes') < 10) {
        axios
        .post(process.env.VUE_APP_AUTH_URL+'/refresh', { "refresh_token": store.state.refreshToken }, {
            headers: {
                'Authorization': 'Bearer '+store.state.authToken,
            }
          }
        )
        .then( function(response){
          console.log('Updating Auth Token')
          store.commit('setAuthToken', response.data.access_token)
          store.commit('setRefreshToken', store.state.refreshToken)
        }).catch(function(err) {
          console.log(err);
        });
      }

    }
  },
  mounted: function() {

    $('#loader').fadeOut()
    this.fetchConfigs(true);
    
  }
}).$mount('#app')

Vue.mixin({
  mounted: function() {
    if(this.$route.params.hasOwnProperty('id')) {
      const id = this.$route.params.id;
      const conf = store.state.configs.find(c => ( id == c.configId ) )
    }
  }
})

// Save current URL for redirection purposes
router.afterEach((to, from) => { 
  sessionStorage.latestUrl = window.location.href
  sessionStorage.latestComponent = to.name

  if(!['ConfigParams', 'ValidateConfig'].includes(to.name))
    $('#loader').fadeOut()
})

Vue.use(VueAxios, axios)

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

jQuery(document).ready(function(){
  
  $(document).on('click', '.toggleMenu', function(){
    $('.toggleMenu, #menu, #app').toggleClass('open')
  })

  $(document).on('click', '.closeMenu', function(){
    $('.closeMenu, #menu, #app').removeClass('open')
  })

  $(document).on('click', '#logOut', function(){
    vm.pooling = ''
  })

  $(document).on('click', 'a.settings', function() {
    /* $('div.settingsMenu').toggleClass("open");
    $('#app').toggleClass("settings"); */

    if($(this).data('id') == $('.settingsMenu').data('id')) {
      $('#app').removeClass("settings");
      $('.settingsMenu').removeClass("open").data('id','');
    } else {
      $('.settingsMenu').addClass("open").data('id',$(this).data('id'));
      $('#app').addClass("settings")
    }

  });

  $(document).on('click', '#menu ul.configurations li a:not(.settings), #topbar a', function() {
    $('#app').removeClass("settings");
    $('.settingsMenu').removeClass("open");
  });
 

  $(document).on('click', '.settingsMenu a.close', function() {
    $('div.settingsMenu').removeClass("open");
    $('#app').toggleClass("settings");
  });

  $(document).on('click', 'ul.configurations li a:not(.settings)', function() {
      $('div.settingsMenu').removeClass("open");
  });

 /*  $(document).on('click','#customParams tr.base:not(.edit) td:not(.action)',function() {
    var paramBase = $(this).parent();
    var paramDetails = $(this).parent().next();
    paramDetails.toggleClass("show");
    paramBase.toggleClass("open");
    $('#customParams tr.details').not(paramDetails).removeClass("show");
    $('#customParams tr.base').not(paramBase).removeClass("open");
    paramBase.find('td.value, td.comment').toggleClass("hidden");
    $('#customParams tr.base').not(paramBase).find('td.value, td.comment').removeClass("hidden");
  });
 */

  $(document).on('click','#defaultParams td:not(.defaultSetButton)',function() {
    var paramBase = $(this).parent();
    var paramDetails = $(this).parent().next();
    paramDetails.toggleClass("show");
    paramBase.toggleClass("open");
    $('#defaultParams tr.details').not(paramDetails).removeClass("show");
    $('#defaultParams tr.base').not(paramBase).removeClass("open");
    paramBase.find('td.value, td.comment').toggleClass("hidden");
    $('#defaultParams tr.base').not(paramBase).find('td.value, td.comment').removeClass("hidden");
  });

  /*$(document).on('click', 'a.search' ,function() {
    $(this).parent().toggleClass('open');
    if($(this).parent().hasClass('open'))
      $(this).parent().addClass('focus');
    if($(this).hasClass('custom'))
      $('.lastEdit').toggle();
    if($(this).text()=='Search') {
      $(this).text('Close')
    } else {
      $(this).text('Search')
      if($(this).prev().val().length)
        $(this).addClass("redClass")
      else
        $(this).removeClass("redClass")
    };
    $(this).siblings('input.searchText').focus()
  });*/

  $(document).on('click', 'a.search' ,function() {
    $(this).parent().addClass('open focus');
    $(this).text('Close').addClass('closeSearch')
    $(this).siblings('input.searchText').focus()
  });

  $(document).on('click', 'a.search.closeSearch', function(){
    $(this).parent().removeClass('open focus');
    $(this).text('Search').removeClass('closeSearch')
    $(this).prev().val('')
    $('tr.base').removeClass("hide")
    $('tr.noResults').removeClass("show")
  });

  $(document).on('focusout', 'input.searchText', function(){
    $(this).parent().removeClass('focus');
  });

  $(document).on('focusin', 'input.searchText', function(){
    $(this).parent().addClass('focus');
  });

  $(document).on('focusin', 'input#homeKeyword', function(){
    $(this).parent().addClass('focus');
  });

  $(document).on('focusout', 'input#homeKeyword', function(){
    $(this).parent().removeClass('focus');
  });

  $('a.filter').click(function() {
    $('#filter').toggleClass("open");
  });

  $('#filter a.close').click(function() {
    $('#filter').toggleClass("open");
  });

  $('#filter ul li').click(function() {
    $(this).toggleClass("open");
  });

  $('.form a.confirm').click(function() {
    $('.form .confirmation').addClass("show");
    $(this).removeClass("confirm");
  });

  $(document).on('click', 'ul.downloadOptions li.option' ,function() {
    $(this).addClass("open");
    var download = $(this).next();
    download.addClass("show");
    $('li.option').not(this).removeClass("open");
    $('li.downloadOption').not(download).removeClass("show");
  });

  $(document).on('click', '#infoBox .overlay' ,function() {
    $('#infoBox').removeClass('show').fadeOut()
  });

  // Set darkmode based on cookies or system wide preferences
  const darkmode = getCookie('darkmode');
  if( (darkmode == 1) || (!darkmode.length && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
    document.cookie = 'darkmode=1; Path=/; SameSite=Lax; Expires=Fri, 31 Dec 9999 23:59:59 GM';
    store.commit('setTheme', 'dark')
    $("body").addClass('darkmode')
  } else {
    document.cookie = 'darkmode=0; Path=/; SameSite=Lax; Expires=Fri, 31 Dec 9999 23:59:59 GM';
    store.commit('setTheme', 'light')
    $("body").removeClass('darkmode')
  }

  // Hide divs on click out
  $(document).click(function(event) { 
    var $target = $(event.target);
    
    if(!$target.closest('.hideOnClick').length)
      $('.hideOnClick').removeClass('show').fadeOut()
  });

  // Hide notifications bar on click out
  $(document).click(function(event) { 
    var $target = $(event.target);
    
    if(!$target.closest('#notificationsBar, #notifications').length)
      $('#notificationsBar.show').removeClass('show')
  });

  // Hide account bar on click out
  $(document).click(function(event) { 
    var $target = $(event.target);
    
    if(!$target.closest('#accountSettings, .account').length)
      $('#accountSettings.show').removeClass('show')
  });
  
  // Detect keyboard input
  document.addEventListener("keyup", event => {
    if(event.keyCode == 27)
      $('.show').removeClass('show').fadeOut()
  })


})
